import { NotifyHelper } from "../../../helpers/toast";
import { eVenderActionsObj } from "../../action-types/user/IVenderActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";

export const venderAction = {
    ...generateActions(eVenderActionsObj, "VENDER"),
    ...generateActionForKey(eVenderActionsObj, "VENDER", "SAVE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eVenderActionsObj, "VENDER", "DELETE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eVenderActionsObj, "VENDER", "SAVE_ERRR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eVenderActionsObj, "VENDER", "DELETE_ERRR", (m) => { NotifyHelper.Error(m) }),
};
